import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import useAuthActions from "@/hooks/useAuthActions";

const AuthContext = createContext(null);

/* Session lives in the backend's httpOnly cookie; we only mirror the user profile in memory. */
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest
  const [loading, setLoading] = useState(true);
  const actions = useAuthActions(setUser);

  useEffect(() => {
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => ({ user, loading, setUser, ...actions }), [user, loading, actions]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
